export const DOMAIN_API_URL = "https://sladost42.ru";
export const DOMAIN_URL = DOMAIN_API_URL;